import { Dropdown, Ripple, initMDB } from "mdb-ui-kit";
initMDB({ Dropdown, Ripple });

import lozad from 'lozad'

const observer = lozad('.lozad-img', {
	load: function(el) {
		el.onerror = function() {
			el.src = el.getAttribute('data-placeholder-background');
		};
		el.src = el.getAttribute('data-src');
	}
});

observer.observe();

// Allowed values for 'sort' and 'order' to prevent manipulation
const validOrderValues = ['ASC', 'DESC'];
const validSortValues = ['popular', 'latest', 'trending', 'alphabetical'];

// Function to validate query parameters on page load
function validateQueryParamsOnLoad() {
    const url = new URL(window.location.href);
    const order = url.searchParams.get('order');
    const sort = url.searchParams.get('sort');

    // Check if 'order' and 'sort' have valid values; if not, clear all query parameters
    if ((order && !validOrderValues.includes(order)) || (sort && !validSortValues.includes(sort))) {
        url.search = ''; // Clear all query parameters
        window.location.href = url.toString(); // Reload page without query parameters
    }
}

// Function to update URL parameters and refresh the page
function updateQueryParams(params: Record<string, string>) {
    const url = new URL(window.location.href);

    // If search parameter is being updated, remove 'page' parameter
    if (params.hasOwnProperty('search')) {
        url.searchParams.delete('page');
    }

    // Update or add each query parameter
    Object.keys(params).forEach(key => {
        url.searchParams.set(key, params[key]);
    });

    // Redirect to the updated URL
    window.location.href = url.toString();
}

// Event listener for changes in the "order" and "sort" radio groups
function setupRadioListeners() {
    const orderRadios = document.querySelectorAll<HTMLInputElement>('input[name="order"]');
    const sortRadios = document.querySelectorAll<HTMLInputElement>('input[name="sort"]');

    // Listen to changes in "order" radio group
    orderRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            if (radio.checked) {
                updateQueryParams({ order: radio.value });
            }
        });
    });

    // Listen to changes in "sort" radio group
    sortRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            if (radio.checked) {
                updateQueryParams({ sort: radio.value });
            }
        });
    });
}

// Event listener for the "Enter" key on the search input
function setupSearchInputListener() {
    const searchInput = document.getElementById('search') as HTMLInputElement;

    if (searchInput) {
        searchInput.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                updateQueryParams({ search: searchInput.value });
            }
        });
    }
}

// Event listener for clicks on the search button
function setupSearchButtonListener() {
    const searchButton = document.getElementById('start_search_by_name') as HTMLButtonElement;
    const searchInput = document.getElementById('search') as HTMLInputElement;

    if (searchButton && searchInput) {
        searchButton.addEventListener('click', () => {
            updateQueryParams({ search: searchInput.value });
        });
    }
}

// Initialize all listeners on page load
document.addEventListener('DOMContentLoaded', () => {
    validateQueryParamsOnLoad(); // Validate 'order' and 'sort' query parameters on page load
    setupRadioListeners();
    setupSearchInputListener();
    setupSearchButtonListener();
});
